import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import {InformationContentType} from '../../../models/navigationTypes';
import {useRewardsTermsAndConditionsPopper} from '../../../screens/rewards/TermsAndConditions';
import Text from '../../themed/Text';

export default function AcceptOnlineOrderingTCs() {
  const styles = useStyles();

  const {textNode, dialogNode} = useRewardsTermsAndConditionsPopper({
    text: 'Terms and Conditions',
    contentType: InformationContentType.TERMS_AND_CONDITIONS,
  });

  const {textNode: privacyPolicyTextNode, dialogNode: privacyPolicyDialogNode} =
    useRewardsTermsAndConditionsPopper({
      text: 'Privacy Policy',
      contentType: InformationContentType.PRIVACY_POLICY,
    });

  return (
    <>
      <View style={styles.container}>
        <Text variant="body2">
          When creating an account, you accept the Online Ordering {textNode},
          which includes how we may send promotional and other messages, and how
          you can opt out or unsubscribe from these messages. To understand how
          we manage your personal data please refer to our{' '}
          {privacyPolicyTextNode}.
        </Text>
      </View>
      {dialogNode}
      {privacyPolicyDialogNode}
    </>
  );
}

const useStyles = makeStyles(() => ({
  container: {
    marginBottom: 16,
  },
}));
